import React from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  CircularProgress,
  Alert,
  Divider,
  Stack
} from "@mui/material";
import { ReceiptLong, OpenInNew } from "@mui/icons-material";
import { useNavigate } from "react-router-dom"; // <--- 1. Import useNavigate

const LinkedRestaurantBillsSection = ({
  colors,
  linkedBills,
  loading,
  error,
}) => {
  const navigate = useNavigate(); // <--- 2. Initialize hook
  
  // Helper to handle navigation
  const handleGoToBill = (billId) => {
      // Navigates to /billing/restaurants/{id}
      navigate(`/billing/restaurants/${billId}`);
  };

  // 1. Loading State
  if (loading) {
    return (
        <Box py={4} display="flex" justifyContent="center">
            <CircularProgress size={24} color="inherit" />
        </Box>
    );
  }

  // 2. Hide section if no bills and no error
  if (!loading && (!linkedBills || linkedBills.length === 0)) {
    return null; 
  }

  return (
    <>
      <Divider sx={{ my: 4 }} />
      
      {/* Header */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Box>
            <Typography variant="h5" fontWeight="bold">
                Linked Restaurant Bills
            </Typography>
            <Typography variant="body2" color="textSecondary">
                Food & Beverage orders charged to this room
            </Typography>
        </Box>
      </Stack>

      {/* Error Message */}
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
      )}

      {/* Bills Table */}
      {linkedBills.length > 0 && (
          <Paper sx={{ backgroundColor: colors.primary[500], overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 300 }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ bgcolor: colors.primary[600] }}>Bill No</TableCell>
                    <TableCell sx={{ bgcolor: colors.primary[600] }}>Date</TableCell>
                    <TableCell sx={{ bgcolor: colors.primary[600] }}>Status</TableCell>
                    <TableCell sx={{ bgcolor: colors.primary[600] }} align="right">Total Amount</TableCell>
                    <TableCell sx={{ bgcolor: colors.primary[600] }} align="center">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {linkedBills.map((bill) => (
                    <TableRow key={bill._id || bill.bill_no} hover>
                      <TableCell>{bill.inv_no || bill.bill_no}</TableCell>
                      <TableCell>
                        {bill.date ? new Date(bill.date).toLocaleDateString("en-IN") : "-"}
                      </TableCell>
                      <TableCell>
                        <Typography 
                            variant="caption" 
                            sx={{ 
                                color: bill.payment_status === "paid" ? colors.greenAccent[500] : colors.redAccent[500],
                                fontWeight: "bold",
                                textTransform: "uppercase"
                            }}
                        >
                            {bill.payment_status || "Unpaid"}
                        </Typography>
                      </TableCell>
                      <TableCell align="right" sx={{ fontWeight: "bold" }}>
                        ₹ {bill.total_amount || bill.grand_total || 0}
                      </TableCell>
                      <TableCell align="center">
                        <Button
                            size="small"
                            color="secondary"
                            endIcon={<OpenInNew sx={{ fontSize: 14 }} />}
                            onClick={() => handleGoToBill(bill._id)}
                        >
                            View Bill
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
      )}
    </>
  );
};

export default LinkedRestaurantBillsSection;